module.exports = __webpack_public_path__ + "img/ertiga-2022.fd9be774.svg";